const initialState = {
  totalSubmissions: 0,
  submissionsInProgress: 0,
  totalClients: 0,
  pendingPriceRequests: 0,
  totalSubmissionsAmount: 0,
  totalProjects: 0,
  projectsInProgress: 0,
  projectsByStage: {},
  projectsCompletionRate: 0,
  recentActivities: [],
  activeProjects: [],
  pipelineValue: 0,
  activeJobsValue: 0,
  monthlyWonValue: { months: [], total_won_count: 0 },
  bidPricesReceived: [],
  clientEvents: [],
  pipelineByStage: {},
  avgProfitMargin: null,
  totalProfitRealized: 0,
  submissionConversion: {},
  conversionDelay: {},
  topClients: [],
  lossReasons: [],
};

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DASHBOARD_DATA':
      return {
        ...state,
        totalSubmissions: action.data.total_submissions || 0,
        submissionsInProgress: action.data.submissions_in_progress || 0,
        totalClients: action.data.total_clients || 0,
        pendingPriceRequests: action.data.pending_price_requests || 0,
        totalSubmissionsAmount: action.data.total_submissions_amount || 0,
        totalProjects: action.data.total_projects || 0,
        projectsInProgress: action.data.projects_in_progress || 0,
        projectsByStage: action.data.projects_by_stage || {},
        projectsCompletionRate: action.data.projects_completion_rate || 0,
        recentActivities: action.data.recent_activities || [],
        activeProjects: action.data.active_projects || [],
        pipelineValue: action.data.pipeline_value || 0,
        activeJobsValue: action.data.active_jobs_value || 0,
        monthlyWonValue: action.data.monthly_won_value || { months: [], total_won_count: 0 },
        bidPricesReceived: action.data.bid_prices_received || [],
        clientEvents: action.data.client_events || [],
        pipelineByStage: action.data.pipeline_by_stage || {},
        avgProfitMargin: action.data.avg_profit_margin ?? null,
        totalProfitRealized: action.data.total_profit_realized || 0,
        submissionConversion: action.data.submission_conversion || {},
        conversionDelay: action.data.conversion_delay || {},
        topClients: action.data.top_clients || [],
        lossReasons: action.data.loss_reasons || [],
      };
    default:
      return state;
  }
};

export default dashboard;
